export enum OrderFinishedCargoOrdersUnbilledListRequestOrder {
  START_TIME_ASC = "START_TIME_ASC",
  START_TIME_DESC = "START_TIME_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
}

export enum OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType {
  PUB_CARGO_2_RAILY = "PUB_CARGO_2_RAILY",
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export type OrderFinishedCargoOrdersUnbilledListQueryParams = {
  lackingBillingType?: OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType[];
  order?: OrderFinishedCargoOrdersUnbilledListRequestOrder;
  limit: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
};

type OrderFinishedCargoOrdersUnbilledListRequest = {
  lackingBillingType?: OrderFinishedCargoOrdersUnbilledListRequestLackingBillingType[];
  order?: OrderFinishedCargoOrdersUnbilledListRequestOrder;
  limit: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
};

export default OrderFinishedCargoOrdersUnbilledListRequest;
